<template>
  <button
      class="button_login"
      @click="authPopupStore.openSignForm"
  >
    Войти
  </button>
  <pButton
      class="button_reg"
      @click="authPopupStore.openLoginForm"
  >
    Регистрация
  </pButton>
</template>

<script setup lang="ts">
import pButton from '@/common/pButton/pButton.vue'
import {useAuthPopup} from "@/authSection/store/authPopup";

const authPopupStore = useAuthPopup()
</script>

<style scoped lang="scss">
.button {
  &_login {
    padding: 14px;
    font: 600 14px/16px "Inter", sans-serif;
    color: #FFF;
    border: none;
    cursor: pointer;
    background: transparent;
  }

  &_reg {
    font-weight: 600;
  }
}
</style>